import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _15mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"15mp"}/>
}
